import React from 'react';
import PropTypes from 'prop-types';
import FlavorImage from './FlavorImage';
import './ProductGrid.scss';
import { getProductImagePath } from '../utils/productImages';

// Helper to group products by category
function groupProducts(products) {
  const groups = {
    Pocket: [],
    OG: [],
    Plus: [],
    X: []
  };
  products.forEach(product => {
    if (product.brand === 'Good Vibes Pocket') groups.Pocket.push(product);
    else if (product.brand === 'Good Vibes' && product.thc?.includes('500mg')) groups.OG.push(product);
    else if (product.brand === 'Good Vibes +' || product.brand === 'Good Vibes Plus' || product.brand === 'Good Vibes + Sleep') groups.Plus.push(product);
    else if (product.brand === 'Good Vibes X') groups.X.push(product);
  });
  return groups;
}

const ProductGrid = ({ products, onSelect }) => {
  const grouped = groupProducts(products);
  // Helper to get category label with THC
  const getCategoryLabel = cat => {
    const labelStyle = { fontSize: '1.5rem', fontWeight: 600, display: 'inline-block', verticalAlign: 'middle' };
    if (cat === 'Pocket') return <><span style={labelStyle}>Pocket</span> <span className="thc-pill">150mg THC</span></>;
    if (cat === 'OG') return <><span style={labelStyle}>Good Vibes</span> <span className="thc-pill">500mg THC</span></>;
    if (cat === 'Plus') return <span style={labelStyle}>Good Vibes Plus</span>;
    if (cat === 'X') return <><span style={labelStyle}>Good Vibes X</span> <span className="thc-pill">1000mg THC</span></>;
    return <span style={labelStyle}>{cat}</span>;
  };

  // Helper to get ratio string for Plus line
  const getRatio = product => {
    // Treat Lemon Dreams as Plus product regardless of brand
    if (
      product.brand === 'Good Vibes +' ||
      product.brand === 'Good Vibes Plus' ||
      (product.displayName.toLowerCase().includes('lemon dreams') && product.brand.toLowerCase().includes('good vibes'))
    ) {
      if (product.displayName.toLowerCase().includes('balance')) {
        return <span className="ratio-label">1:1 THC:CBD 500mg</span>;
      }
      if (product.displayName.toLowerCase().includes('lemon')) {
        return <span className="ratio-label">1:1:1 THC:CBD:CBN 300mg</span>;
      }
    }
    return null;
  };

  return (
    <div className="product-grid">
      {Object.entries(grouped).map(([category, items]) => (
        items.length > 0 && (
          <div key={category} className="product-category">
            <h2>{getCategoryLabel(category)}</h2>
            <div className="product-category-grid">
              {items.map(product => (
                <div
                  key={product.canonicalName}
                  className="product-card"
                  onClick={() => onSelect(product)}
                >
                  <FlavorImage 
                    src={getProductImagePath({ imagePath: product.imagePath })} 
                    alt={product.displayName} 
                  />
                  <div className="product-name">{product.displayName}</div>
                  {/* Show ratio for Plus line */}
                  {category === 'Plus' && getRatio(product) && (
                    <div className="product-ratio">{getRatio(product)}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )
      ))}
    </div>
  );
};

ProductGrid.propTypes = {
  products: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default ProductGrid;
